import { Box, Typography } from "@mui/material";
import { sanitizeTicketHtml } from "../utils/sanitizeHtml";

function looksLikeHtml(value: string) {
  return /<\/?[a-z][\s\S]*>/i.test(value || "");
}

export function TicketHtml({ html }: { html: string }) {
  if (!html) {
    return null;
  }
  if (!looksLikeHtml(html)) {
    return <Typography sx={{ whiteSpace: "pre-wrap" }}>{html}</Typography>;
  }
  return (
    <Box
      sx={{
        "& img": { maxWidth: "100%", borderRadius: 1, display: "block", my: 1 },
        "& p": { m: "0 0 8px" },
        "& ul, & ol": { m: "0 0 8px", pl: 3 },
      }}
      dangerouslySetInnerHTML={{ __html: sanitizeTicketHtml(html) }}
    />
  );
}
